import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";

const TinNhanSMS = (props) => {
    const { register, handleSubmit, errors } = useForm(); // Initialize the hook
    const { guitinnhan, showModalGuiTinNhan, data, guiTinNhan } = props;
    const { showModalTinNhan } = guitinnhan;
    const { CustomerName, ChoVayId } = data;
    const onSubmit = (data) => {
      guiTinNhan(data);
    };
    const [NoiDung, setNoiDung] = useState("");
    const handleChange = (event) => setNoiDung(event.target.value);

    // Close the modal when Escape key is pressed
    const handleKeyDown = (event) => {
        if (event.key === "Escape") {
            showModalGuiTinNhan();
        }
    };

    useEffect(() => {
        // Add keydown event listener when modal is open
        if (showModalTinNhan) {
            document.addEventListener("keydown", handleKeyDown);
        }
        // Cleanup event listener on unmount or when modal is closed
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [showModalTinNhan]); // Effect runs when showModalTinNhan changes

  return (
    <Modal
      show={showModalTinNhan}
      size="modal-dialog modal-lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
          <img  src="/app-assets/images/logo-message-v2.png"/>
          </span>
          Gửi tin nhắn
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={showModalGuiTinNhan}
        >
           <img  src="/app-assets/images/icon-dong-popup-v2.png"/>
        </button>
      </Modal.Header>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body className="">
          <div className="form form-horizontal">
            <div className="form-body">
              <div className="form-body">
                <div className="form-group row ">
                  <label className="col-md-2 label-control"><span class= "font-nguoi-nhan">Người nhận :</span></label>
                  <div className="col-md-10 font-nguoi-nhan" style={{ textAlign:"left"}}>{CustomerName}</div>
                  <input
                    type="hidden"
                    name={"TenNguoiNhan"}
                    value={CustomerName}
                    ref={register}
                  ></input>
                  <input
                    type="hidden"
                    name={"ChoVayID"}
                    value={ChoVayId}
                    ref={register}
                  ></input>
                </div>
                <div className={"form-group row"} >
                  <label className={"col-md-3 label-control color7-bold"}>
                    Số điện thoại <span className="canh-bao-red">*</span>
                  </label>
                  <div class={"col-md-12"}>
                    <input
                      type="tel"
                      className={"form-control input-sm"}
                      ref={register({
                        required: "Hãy nhập số điện thoại",
                        pattern: {
                          value: /^[0-9\b]+$/,
                          message: "Chỉ được nhập số",
                        },
                        maxLength: {
                          value: 11,
                          message: "Nhập 10-11 chữ số.",
                        },
                        minLength: {
                          value: 10,
                          message: "Nhập 10-11 chữ số.",
                        },
                      })}
                      name="SoDienThoai"
                      placeholder="Nhập số điện thoại"
                    />
                    <span className="canh-bao-red">
                      {errors.SoDienThoai && errors.SoDienThoai.message}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-4 label-control" for="projectinput1">
                  <span className=" color7-bold">Nội dung</span> (Tối đa {160 - NoiDung.length} ký tự)   
                  <span className="canh-bao-red">*</span>
                  </label>
                  <div className="col-md-12">
                    <textarea
                      className="input-sm textarea-v2"
                      name="NoiDung"
                      ref={register({
                        required: "Hãy nhập nội dung tin nhắn",
                      })}
                      onChange={handleChange}
                      placeholder="Nhập số nội dung tin"
                    ></textarea>
                    <p className="canh-bao-red">
                      {errors.NoiDung && errors.NoiDung.message}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
        <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={showModalGuiTinNhan}
          >
            <span>
              <i className="mdi mdi-close"></i>
            </span>
            &nbsp;  Đóng
          </button>
          <button type="submit" className="btn btn-new-main button-popup-submit">
            <span>
            <img  src="/app-assets/images/icon-send-v2.png"/>
            </span>
            &nbsp;   Gửi tin
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
export default TinNhanSMS;
